import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Search(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Search", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36 36.75a.75.75 0 0 1-.53-.22l-7.5-7.5a.75.75 0 0 1 1.06-1.06l7.5 7.5a.75.75 0 0 1-.53 1.28Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.5 35.25c8.698 0 15.75-7.052 15.75-15.75S28.198 3.75 19.5 3.75 3.75 10.802 3.75 19.5s7.052 15.75 15.75 15.75Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M19.5 32.25c7.042 0 12.75-5.708 12.75-12.75S26.542 6.75 19.5 6.75 6.75 12.458 6.75 19.5s5.708 12.75 12.75 12.75Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m34.217 37.446 6.133 6.136a2.285 2.285 0 0 0 3.228 0 2.285 2.285 0 0 0 0-3.225l-6.136-6.136a1.591 1.591 0 0 0-2.255 0l-.974.975a1.594 1.594 0 0 0 .004 2.25Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.32 28.076a1.898 1.898 0 1 0 3.742.636 1.898 1.898 0 0 0-3.743-.636Zm5.56-13.817c.074-.437.398-.831.877-1.006.677-.206 1.383.17 1.6.785.082.271 2.306 7.197-2.058 11.718-.47.498-1.302.484-1.8.014s-.484-1.302-.015-1.8c3.34-3.41 1.488-9.118 1.498-9.18a.719.719 0 0 1-.102-.531Z",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
Search.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Search"
};
validateTidalLicense();
export {
  Search
};
//# sourceMappingURL=Search.js.map
